import { FeePlanRate } from '@square/dashboard-protos/models/squareup/pricingplan/common';
// Divisor to convert basis points to percentage (1 bps = 0.0001 = 0.01%, so 180 bps = 0.018 = 1.8%)
const BASIS_POINTS_DIVISOR = 10000;
const DEFAULT_SMIRF_BASIS_POINTS = 250;
export let JpSmirfState = /*#__PURE__*/function (JpSmirfState) {
  JpSmirfState["ENROLLMENT_FORM"] = "ENROLLMENT_FORM";
  JpSmirfState["ENROLLMENT_SUCCESS"] = "ENROLLMENT_SUCCESS";
  JpSmirfState["ENROLLMENT_FAILURE"] = "ENROLLMENT_FAILURE";
  JpSmirfState["ENROLLMENT_NO_LONGER_ELIGIBLE"] = "ENROLLMENT_NO_LONGER_ELIGIBLE";
  JpSmirfState["INELIGIBLE"] = "INELIGIBLE";
  JpSmirfState["SERVER_ERROR"] = "SERVER_ERROR";
  return JpSmirfState;
}({});
export function isInSmirfPricingPlan(response) {
  return response?.cpFeeRate && response?.planName?.includes('SMIRF');
}
export function getSmirfRate(response) {
  const defaultRate = FeePlanRate.create({
    cpBasisPoints: DEFAULT_SMIRF_BASIS_POINTS,
    cpInterchangeCents: 0
  });
  if (isInSmirfPricingPlan(response)) {
    return response?.cpFeeRate ?? defaultRate;
  }
  return defaultRate;
}
export function getFormattedSmirfCpRate(intl, response) {
  return getFormattedCpRate(intl, getSmirfRate(response));
}
export function getFormattedCpRate(intl, cpFeeRate) {
  const basisPoints = cpFeeRate.cpBasisPoints;
  const interchangeCents = cpFeeRate.cpInterchangeCents;
  if (basisPoints) {
    // Convert basis points to percentage
    const formattedPercentage = intl.formatNumber(basisPoints / BASIS_POINTS_DIVISOR, {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
    if (!interchangeCents) {
      return formattedPercentage;
    }

    // Format cents
    const formattedCents = intl.formatNumber(interchangeCents, {
      style: 'currency',
      currency: 'JPY',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      currencyDisplay: 'narrowSymbol'
    });
    return `${formattedPercentage} + ${formattedCents}`;
  }
  throw new Error('Basis points is required');
}